module.exports = "/_next/static/images/483e0059c482c59fa2aa1b2b4d8dcd87-boy-looking-to-the-front-md@1x.jpg.webp";